import * as moment from 'moment';

const DEFAULT_URL = 'https://ast.maxhawkins.me';

export interface ITrack {
  url: string,
  id: string,
  filename: string,
  extension: string,
  created_at: string,
  source: string,
  size: number,
  duration_sec: number,
  metadata: any,
}

export interface IUpdate {
	size?: number,
	duration_sec?: number,
	metadata?: {[k: string]: any},
	created_at?: string,
	filename?: string,
  source?: string,
  mask?: string,
}

export interface IListOptions {
  limit?: number,
  offset?: number,
}

export interface IListResponse {
  tracks: ITrack[],
  total: number,
}

export type AuthFunc = () => Promise<string | null>;

export class AudiostoreAPI {
  private baseURL: string;
  private authFunc: AuthFunc;

  constructor(baseURL = DEFAULT_URL, authFunc: AuthFunc = async () => null) {
    this.baseURL = baseURL;
    this.authFunc = authFunc;
  }

  public list(opts: IListOptions = { }): Promise<IListResponse> {
    const limit = opts.limit || 10;
    const offset = opts.offset || 0;

    const path = '/tracks'
      + '?limit=' + limit
      + '&offset=' + offset;

    return this._fetch(path);
  }

  public update(trackID: string, update: IUpdate): Promise<ITrack> {
    update.mask = Object.keys(update).join(',');

    const path = `/tracks/${trackID}`;
    return this._fetch(path, {
      body: JSON.stringify(update),
      method: 'PATCH',
    });
  }

  public get(trackID: string): Promise<ITrack> {
    const path = `/tracks/${trackID}.json`;
    return this._fetch(path);
  }

  public upload(file: File): Promise<ITrack> {
    const body = new FormData();

    body.append('file', file, file.name);

    const created = moment(file.lastModified).format();
    body.append('created', created);

    return this._fetch('/upload', {
      body,
      method: 'POST',
    })
  }

  public async _fetch(path: string, opts: RequestInit = { }) {
    const url = this.baseURL + path;

    const token = await this.authFunc();
    if (token) {
      opts.headers = {
        ...opts.headers,
        'Authorization': `Bearer ${token}`,
      };
    }

    const resp = await fetch(url, opts);
    const data = await resp.json();
    if (resp.status !== 200) {
      throw new Error(`failed to fetch ${path}: ${data.error}`);
    }

    return data;
  }

}

export default AudiostoreAPI;



// WEBPACK FOOTER //
// ./src/api/AudiostoreAPI.ts